<template>
  <div>
    <div class="row">
      <b-col sm="3" class="text-left pt-2 bg-warning text-dark rounded font-weight-bold">Total Pending: {{totalPending.toLocaleString('en') || 0}} kr</b-col>
      <b-col sm="5" class="text-right pt-2">
        <router-link to="/invoices/new-company">
          New Client
        </router-link>
      </b-col>
      <b-col sm="4" class="position-relative">
        <b-form-input class="ml-3"
        id="filter"
        v-model="filter"
        type="text"
        placeholder="Filter">
        </b-form-input>
      </b-col>
    </div>
    <div class="row">
      <div class="w-100 mt-3 overflow-hidden rounded">
        <table class="table">
          <thead>
          <tr>
            <th scope="col">Org. Number</th>
            <th scope="col">Name</th>
            <th class="d-none d-sm-table-cell text-center" scope="col">Email</th>
            <th class="d-none d-sm-table-cell text-center" scope="col">Phone</th>
            <th class="d-none d-sm-table-cell text-center" scope="col">Pending</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(row, i) in filteredList" v-bind:key="i" @click="goToClient(row._id)" class="pointer" :class="row.pending ? 'bg-warning text-dark' : ''">
            <th scope="row">{{!row.ttexId ? 'NOT IN TTEX' : row.oNumber || 'Private'}}</th>
            <td>{{row.name || "No name"}}</td>
            <td class="d-none d-sm-table-cell text-center">{{row.email || '/'}}</td>
            <td class="d-none d-sm-table-cell text-center">{{row.phone || '/'}}</td>
            <td class="d-none d-sm-table-cell text-center">{{row.pending ? row.pending.reduce((total, item) => total + (item.qtt * item.price), 0).toLocaleString('en') : 0}} kr</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

import fixed from '../../fixed';

const API_URL = `${fixed.API_URL}/admin`;
export default {
  data: () => ({
    clients: [],
    filter: '',
    totalPending: 0,
  }),
  async mounted() {
    try {
      const { data } = await axios.get(`${API_URL}/clients`, { withCredentials: true });
      this.clients = data;
      // Calculate total pending
      data.forEach((row) => {
        if (row.pending && row.pending.length) {
          row.pending.forEach((item) => {
            this.totalPending += (item.price * item.qtt);
          });
        }
      });
    } catch (err) {
      this.$toast.error('can\'t get registered clients');
    }
  },
  computed: {
    filteredList() {
      return this.clients.filter((row) => row.name.toLowerCase().match(this.filter.toLowerCase())
        || row.email?.match(this.filter))
        .sort((a, b) => (b.pending && b.pending.length) || 0 - (a.pending && a.pending.length) || 0);
    },
  },
  methods: {
    goToClient(id) {
      this.$router.push({ name: 'client', params: { id } });
    },
  },
};
</script>

<style>

</style>
